import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ApplicationUtilitiesState, featureKey, State } from './combiner';

export const selectApplicationUtilitiesState = createFeatureSelector<State, ApplicationUtilitiesState>(featureKey);

export const selectFinancialEntityBranchesState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.financialEntityBranches
);
export const selectFinancialEntityBranchState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.financialEntityBranch
);
export const selectInformativeMessagesState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.informativeMessages
);
export const selectValidateZipCodeState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.validateZipCode
);
export const selectValidateVertiRelationsState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.validateVertiRelations
);
export const selectValidatePartnershipCardState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.validatePartnershipCard
);
export const selectPartnershipValidationStepState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.partnershipValidationStep
);
export const selectValidateFiscalCodeState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.validateFiscalCode
);
export const selectPostUserState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.postUser
);
export const selectUsersIdState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.usersId
);
export const selectGetUserByIdState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.getUserById
);
export const selectParticipantsState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.participants
);
export const selectPoliciesState = createSelector(
  selectApplicationUtilitiesState,
  (state: ApplicationUtilitiesState) => state.policies
);
